import { Pipe } from '@angular/core';
var PercentagePipe = (function () {
    function PercentagePipe() {
    }
    PercentagePipe.prototype.transform = function (num, total, floor) {
        if (total === void 0) { total = 100; }
        if (floor === void 0) { floor = false; }
        if (isNaN(num)) {
            return num;
        }
        var percent = num * 100 / total;
        return floor ? Math.floor(percent) : percent;
    };
    return PercentagePipe;
}());
export { PercentagePipe };
PercentagePipe.decorators = [
    { type: Pipe, args: [{ name: 'percentage' },] },
];
/** @nocollapse */
PercentagePipe.ctorParameters = function () { return []; };
//# sourceMappingURL=percentage.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/percentage.js
// module id = 241
// module chunks = 4